var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature1A3C9Fc1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 125,
    viewBox: "0 0 163 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.953 72.8478C158.904 72.8573 158.856 72.8669 158.798 72.886C158.847 72.8573 158.895 72.8573 158.953 72.8478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M160.012 72.9244C160.436 73.1634 160.697 73.6606 160.697 74.3776L160.706 79.3202C160.706 80.7734 159.646 82.5707 158.336 83.3164C159.704 82.5325 160.716 80.8021 160.706 79.3871L160.697 74.3107C160.697 74.1386 160.677 73.9665 160.649 73.8231C160.639 73.7753 160.62 73.737 160.61 73.6892C160.581 73.5936 160.562 73.498 160.523 73.412C160.504 73.3642 160.465 73.3355 160.446 73.2877C160.408 73.2208 160.369 73.1443 160.321 73.0965C160.282 73.0583 160.244 73.0391 160.205 73.0009C160.07 72.8862 159.926 72.8001 159.752 72.7619L160.041 72.9244C160.022 72.9244 160.012 72.9244 160.012 72.9244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.81 72.8478C159.762 72.8287 159.714 72.8096 159.656 72.8C159.714 72.8096 159.762 72.8287 159.81 72.8478Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.251 72.781C159.309 72.7714 159.357 72.781 159.415 72.781C159.357 72.781 159.309 72.7714 159.251 72.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.798 72.8765C158.846 72.8574 158.895 72.8574 158.952 72.8383C159.058 72.8096 159.155 72.7809 159.251 72.7714C159.309 72.7618 159.357 72.7714 159.415 72.7714C159.502 72.7714 159.579 72.7714 159.656 72.7809C159.714 72.7905 159.762 72.8192 159.81 72.8287C159.877 72.8478 159.945 72.867 160.012 72.9052C160.022 72.9052 160.022 72.9052 160.032 72.9148L159.743 72.7522C159.376 72.6662 158.923 72.7427 158.432 73.0199L158.307 73.0964C158.48 73.0104 158.644 72.9339 158.798 72.8765Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.509 69.7981C158.576 69.7694 158.634 69.7503 158.702 69.7216C158.808 69.6833 158.904 69.6355 159.01 69.5973C159.078 69.5782 159.145 69.5591 159.203 69.5399C159.299 69.5112 159.396 69.4826 159.482 69.4634C159.55 69.4443 159.617 69.4443 159.685 69.4348C159.771 69.4252 159.858 69.4061 159.945 69.3965C160.012 69.387 160.08 69.3965 160.147 69.3965C160.224 69.3965 160.311 69.387 160.388 69.3965C160.456 69.3965 160.514 69.4156 160.571 69.4156C160.648 69.4252 160.726 69.4252 160.793 69.4443C160.851 69.4539 160.909 69.473 160.966 69.4921C161.034 69.5113 161.111 69.5304 161.178 69.5495C161.236 69.5686 161.284 69.5973 161.342 69.626C161.41 69.6547 161.468 69.6833 161.535 69.712H161.545L72.0171 18.1059C71.1112 17.5896 69.8584 17.6566 68.4803 18.4501L158.008 70.0562C158.172 69.9606 158.336 69.8745 158.509 69.7981Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.08392 70.0181L3.1032 72.5611L92.6308 124.177L92.6019 121.624L3.08392 70.0181Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M93.1801 120.639L94.4329 119.922L4.90531 68.3161L3.65251 69.0331C3.33448 69.2148 3.08392 69.6545 3.08392 70.0178L92.6115 121.624C92.6019 121.261 92.8621 120.821 93.1801 120.639Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.345 83.3164C159.656 82.5612 160.726 80.7734 160.716 79.3203L160.706 74.3776C160.706 73.6606 160.436 73.1635 160.022 72.9245C159.964 72.8862 159.887 72.8767 159.82 72.848C159.771 72.8289 159.723 72.8098 159.665 72.8002C159.588 72.7811 159.502 72.7906 159.424 72.7906C159.367 72.7906 159.318 72.7811 159.261 72.7906C159.164 72.8002 159.058 72.8289 158.962 72.8576C158.914 72.8671 158.866 72.8767 158.808 72.8958C158.654 72.9532 158.49 73.0201 158.326 73.1157L93.1702 110.429C92.9486 110.554 92.7655 110.515 92.6691 110.372C92.698 110.41 92.7173 110.448 92.7558 110.467L4.87616 59.7983L4.90507 68.3069L94.4327 119.913L158.345 83.3164Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.5728 110.075C92.5728 110.171 92.592 110.248 92.6209 110.314C92.592 110.248 92.5728 110.171 92.5728 110.075Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.7464 110.458C92.7078 110.439 92.6885 110.4 92.6596 110.362C92.65 110.343 92.6307 110.333 92.6211 110.314C92.5922 110.247 92.5729 110.171 92.5729 110.075L92.5633 107.532L3.04529 55.9261L3.05493 58.4692C3.05493 58.6508 3.12238 58.7847 3.22839 58.842L4.88595 59.798L92.7464 110.458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.981 72.8862C162.981 71.3278 162.422 70.2284 161.526 69.7122C161.468 69.6739 161.4 69.6548 161.333 69.6261C161.275 69.5974 161.227 69.5688 161.169 69.5496C161.102 69.521 161.034 69.5114 160.957 69.4923C160.899 69.4732 160.841 69.454 160.784 69.4445C160.706 69.4254 160.629 69.4254 160.562 69.4158C160.504 69.4062 160.437 69.3967 160.379 69.3967C160.302 69.3967 160.225 69.3967 160.138 69.3967C160.07 69.3967 160.013 69.3967 159.935 69.3967C159.849 69.4062 159.762 69.4253 159.675 69.4349C159.608 69.4445 159.54 69.454 159.473 69.4636C159.377 69.4827 159.29 69.5114 159.193 69.5401C159.126 69.5592 159.058 69.5688 159.001 69.5974C158.904 69.6357 158.798 69.6739 158.692 69.7217C158.625 69.7504 158.567 69.7695 158.5 69.7982C158.336 69.8747 158.162 69.9607 157.989 70.0563L92.5536 107.532L92.5633 110.075C92.5633 110.171 92.5826 110.248 92.6115 110.314C92.6211 110.334 92.6404 110.343 92.65 110.362C92.756 110.506 92.9391 110.544 93.1511 110.42L158.307 73.106L158.432 73.0296C158.924 72.7523 159.367 72.6758 159.743 72.7619C159.916 72.8001 160.061 72.8862 160.196 73.0009C160.234 73.0296 160.273 73.0582 160.311 73.0965C160.359 73.1538 160.398 73.2208 160.437 73.2877C160.465 73.3259 160.494 73.3642 160.514 73.412C160.552 73.498 160.581 73.5936 160.6 73.6892C160.61 73.737 160.629 73.7753 160.639 73.8231C160.668 73.976 160.687 74.1385 160.687 74.3106L160.697 79.3871C160.697 80.8116 159.695 82.5324 158.326 83.3164L94.4232 119.922L93.1704 120.639C92.8524 120.821 92.6018 121.261 92.6018 121.624L92.6307 124.177L158.047 86.7102C160.793 85.1424 163.01 81.3278 163 78.1921L162.981 72.8862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.5633 107.542L157.998 70.0659L68.4804 18.4502L3.04529 55.9263L92.5633 107.542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.907 56.1556C155.859 56.1651 155.811 56.1747 155.753 56.1938C155.811 56.1747 155.859 56.1651 155.907 56.1556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.967 56.2322C157.391 56.4617 157.651 56.9684 157.651 57.6854L157.661 62.628C157.661 64.0812 156.601 65.8785 155.29 66.6242C156.659 65.8403 157.671 64.1099 157.661 62.695L157.651 57.6185C157.651 57.4464 157.632 57.2743 157.603 57.1309C157.594 57.0831 157.574 57.0448 157.565 56.997C157.536 56.9014 157.516 56.8058 157.478 56.7198C157.459 56.672 157.42 56.6433 157.401 56.5955C157.362 56.5286 157.324 56.4521 157.276 56.4043C157.237 56.3661 157.198 56.3469 157.16 56.3087C157.025 56.194 156.88 56.1079 156.707 56.0697L156.996 56.2322C156.986 56.2322 156.977 56.2322 156.967 56.2322Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.765 56.1557C156.717 56.1365 156.668 56.1174 156.611 56.1078C156.668 56.1174 156.717 56.1365 156.765 56.1557Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M156.206 56.0888C156.264 56.0792 156.312 56.0888 156.37 56.0888C156.312 56.0984 156.264 56.0888 156.206 56.0888Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.753 56.1938C155.801 56.1747 155.85 56.1747 155.907 56.1556C156.013 56.1269 156.11 56.0982 156.206 56.0887C156.264 56.0791 156.312 56.0887 156.37 56.0887C156.457 56.0887 156.534 56.0887 156.611 56.0982C156.669 56.1078 156.717 56.1365 156.765 56.146C156.833 56.1652 156.9 56.1843 156.967 56.2225C156.977 56.2225 156.977 56.2225 156.987 56.2321L156.698 56.0696C156.331 55.9835 155.878 56.06 155.387 56.3372L155.262 56.4137C155.435 56.3181 155.599 56.2416 155.753 56.1938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.464 53.1155C155.532 53.0868 155.589 53.0677 155.657 53.039C155.763 53.0008 155.859 52.953 155.965 52.9148C156.033 52.8956 156.1 52.8765 156.158 52.8574C156.254 52.8287 156.351 52.8 156.437 52.7809C156.505 52.7618 156.572 52.7618 156.64 52.7522C156.727 52.7427 156.813 52.7236 156.9 52.714C156.967 52.7044 157.035 52.714 157.102 52.714C157.179 52.714 157.266 52.7044 157.343 52.714C157.411 52.714 157.469 52.7331 157.526 52.7331C157.603 52.7427 157.681 52.7427 157.748 52.7618C157.806 52.7714 157.864 52.7905 157.921 52.8096C157.989 52.8287 158.066 52.8478 158.134 52.867C158.191 52.8861 158.24 52.9148 158.297 52.9434C158.365 52.9721 158.423 53.0008 158.49 53.0295H158.5L68.9721 1.42336C68.0662 0.897551 66.8134 0.974033 65.4353 1.76753L154.963 53.3736C155.127 53.278 155.3 53.192 155.464 53.1155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0.0385742 53.3259L0.0674852 55.8785L89.5854 107.485L89.5662 104.942L0.0385742 53.3259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M90.1348 103.947L91.3876 103.23L1.85997 51.624L0.607157 52.341C0.289136 52.5226 0.0385742 52.9624 0.0385742 53.3257L89.5662 104.932C89.5662 104.578 89.8168 104.129 90.1348 103.947Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.3 66.6242C156.611 65.8689 157.68 64.0812 157.671 62.628L157.661 57.6854C157.661 56.9684 157.391 56.4712 156.977 56.2322C156.919 56.194 156.842 56.1844 156.775 56.1557C156.726 56.1366 156.678 56.1175 156.62 56.1079C156.543 56.0888 156.457 56.0984 156.379 56.0984C156.322 56.0984 156.273 56.0888 156.216 56.0984C156.119 56.1079 156.013 56.1366 155.917 56.1653C155.869 56.1749 155.82 56.1844 155.763 56.2035C155.608 56.2609 155.445 56.3278 155.281 56.4234L90.1155 93.7274C89.8939 93.8517 89.7107 93.8135 89.6144 93.6701C89.6433 93.7083 89.6626 93.7465 89.7011 93.7657L1.8407 43.1156L1.86961 51.6242L91.3972 103.23L155.3 66.6242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.5278 93.3928C89.5278 93.4884 89.547 93.5649 89.576 93.6318C89.547 93.5649 89.5278 93.4789 89.5278 93.3928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.7011 93.7657C89.6625 93.7466 89.6433 93.7083 89.6143 93.6701C89.6047 93.651 89.5854 93.6414 89.5758 93.6223C89.5469 93.5554 89.5276 93.4789 89.5276 93.3833L89.518 90.8403L0 39.2437L0.00963699 41.7867C0.00963699 41.9684 0.0770959 42.1022 0.183103 42.1691L1.84066 43.1252L89.7011 93.7657Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M159.945 56.1938C159.945 54.6354 159.386 53.536 158.49 53.0198C158.432 52.9815 158.365 52.9624 158.297 52.9337C158.239 52.905 158.191 52.8764 158.133 52.8572C158.066 52.8286 157.998 52.819 157.921 52.7999C157.863 52.7808 157.806 52.7616 157.748 52.7521C157.671 52.733 157.594 52.733 157.526 52.7234C157.468 52.7138 157.401 52.7043 157.343 52.7043C157.266 52.7043 157.189 52.7043 157.102 52.7043C157.035 52.7043 156.977 52.7043 156.9 52.7043C156.813 52.7138 156.726 52.733 156.639 52.7425C156.572 52.7521 156.505 52.7616 156.437 52.7712C156.341 52.7903 156.254 52.819 156.158 52.8477C156.09 52.8668 156.023 52.8764 155.965 52.905C155.869 52.9433 155.763 52.9815 155.657 53.0293C155.589 53.058 155.531 53.0771 155.464 53.1058C155.3 53.1823 155.126 53.2683 154.953 53.3639L89.5179 90.84L89.5275 93.3831C89.5275 93.4787 89.5468 93.5551 89.5757 93.6221C89.5853 93.6412 89.6046 93.6507 89.6143 93.6699C89.7203 93.8133 89.9034 93.8515 90.1154 93.7272L155.271 56.4137L155.396 56.3372C155.888 56.0599 156.331 55.9834 156.707 56.0695C156.88 56.1077 157.025 56.1938 157.16 56.3085C157.198 56.3372 157.237 56.3659 157.276 56.4041C157.324 56.4615 157.362 56.5284 157.401 56.5953C157.43 56.6335 157.459 56.6718 157.478 56.7196C157.516 56.8056 157.545 56.9012 157.565 56.9968C157.574 57.0446 157.594 57.0829 157.603 57.1307C157.632 57.2836 157.651 57.4462 157.651 57.6182L157.661 62.6947C157.661 64.1192 156.659 65.84 155.29 66.624L91.3778 103.23L90.125 103.947C89.807 104.129 89.5564 104.569 89.5564 104.932L89.5853 107.484L155.001 70.0179C157.748 68.45 159.964 64.6355 159.955 61.4997L159.945 56.1938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.5276 90.8498L154.953 53.3737L65.4351 1.76758L0 39.2437L89.5276 90.8498Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.2747 51.28C45.3133 51.2895 45.3422 51.2895 45.3711 51.2991C45.3422 51.2895 45.3133 51.2895 45.2747 51.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.5615 51.3372C44.282 51.4902 44.0989 51.8343 44.0989 52.3123L44.0893 55.6297C44.0893 56.6049 44.8024 57.8095 45.6794 58.3162C44.7542 57.7903 44.0796 56.6336 44.0893 55.6775L44.0989 52.2645C44.0989 52.1498 44.1085 52.0351 44.1278 51.9395C44.1375 51.9108 44.1471 51.8821 44.1567 51.8534C44.176 51.7865 44.1953 51.7196 44.2146 51.6718C44.2338 51.6431 44.2531 51.6144 44.2724 51.5858C44.3013 51.538 44.3206 51.4902 44.3591 51.4519C44.3784 51.4232 44.4073 51.4137 44.4362 51.385C44.5229 51.3085 44.6289 51.2512 44.7446 51.2225L44.5518 51.3372H44.5615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.6963 51.28C44.7348 51.2705 44.7638 51.2514 44.8023 51.2418C44.7638 51.2514 44.7348 51.2705 44.6963 51.28Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.0723 51.2324C45.0337 51.2324 44.9952 51.2324 44.9662 51.2324C45.0048 51.2419 45.0337 51.2324 45.0723 51.2324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.3807 51.3087C45.3421 51.2991 45.3132 51.2991 45.2843 51.2896C45.2168 51.2704 45.1494 51.2513 45.0819 51.2418C45.0434 51.2418 45.0048 51.2418 44.9759 51.2418C44.9181 51.2418 44.8603 51.2418 44.8121 51.2513C44.7735 51.2609 44.7446 51.2704 44.7061 51.2896C44.6579 51.3087 44.6097 51.3182 44.5712 51.3374H44.5615L44.7543 51.2226C45.0048 51.1653 45.3036 51.2131 45.6312 51.4043L45.7179 51.4521C45.5927 51.3852 45.4867 51.3374 45.3807 51.3087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.5733 49.2341C45.5347 49.215 45.4865 49.2055 45.448 49.1863C45.3805 49.1577 45.3131 49.129 45.2456 49.1003C45.1974 49.0812 45.1589 49.0716 45.1107 49.062C45.0432 49.0429 44.9854 49.0238 44.9179 49.0143C44.8698 49.0047 44.8312 49.0047 44.783 48.9951C44.7252 48.9856 44.6674 48.976 44.6096 48.9664C44.5614 48.9664 44.5228 48.9664 44.4746 48.9664C44.4168 48.9664 44.3686 48.9569 44.3108 48.9664C44.2723 48.9664 44.2241 48.976 44.1855 48.9856C44.1373 48.9951 44.0795 48.9951 44.0313 49.0047C43.9928 49.0142 43.9542 49.0238 43.9157 49.0334C43.8675 49.0429 43.8193 49.0525 43.7808 49.0716C43.7422 49.0812 43.7037 49.1099 43.6651 49.1194C43.6266 49.1385 43.5784 49.1577 43.5399 49.1768C43.5399 49.1768 43.5398 49.1768 43.5302 49.1768L103.655 14.5114C104.263 14.1577 105.101 14.215 106.026 14.7408L45.9105 49.4158C45.7949 49.3489 45.6889 49.2915 45.5733 49.2341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.961 49.3775L149.942 51.0888L89.8168 85.7542L89.8361 84.0429L149.961 49.3775Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.4506 83.3831L88.6122 82.9051L148.737 48.2397L149.576 48.7178C149.788 48.842 149.961 49.1384 149.961 49.3774L89.8361 84.0428C89.8361 83.8038 89.6626 83.5074 89.4506 83.3831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M45.6889 58.3163C44.8119 57.8096 44.0892 56.605 44.0988 55.6299L44.1084 52.3125C44.1084 51.8345 44.2819 51.4903 44.571 51.3374C44.6096 51.3182 44.6577 51.2991 44.7059 51.2895C44.7445 51.28 44.7734 51.2609 44.8119 51.2513C44.8601 51.2417 44.9179 51.2417 44.9758 51.2417C45.0143 51.2417 45.0432 51.2322 45.0818 51.2417C45.1492 51.2513 45.2167 51.2704 45.2841 51.2895C45.3227 51.2991 45.3516 51.2991 45.3805 51.3087C45.4865 51.3469 45.5925 51.3947 45.7082 51.4616L89.4601 76.519C89.6046 76.605 89.7299 76.5763 89.7974 76.4807C89.7781 76.5094 89.7588 76.5285 89.7396 76.5477L148.747 42.5228L148.728 48.2398L88.612 82.8956L45.6889 58.3163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.8552 76.2897C89.8552 76.3566 89.8456 76.4044 89.8263 76.4522C89.8456 76.4044 89.8552 76.347 89.8552 76.2897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.7396 76.538C89.7685 76.5284 89.7782 76.4997 89.7974 76.471C89.8071 76.4615 89.8167 76.4519 89.8264 76.4424C89.8456 76.4041 89.8553 76.3468 89.8553 76.2798L89.8649 74.5781L149.99 39.9127L149.98 41.6144C149.98 41.7387 149.932 41.8248 149.865 41.8726L148.747 42.5131L89.7396 76.538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M42.5667 51.3087C42.5667 50.2571 42.9425 49.521 43.5497 49.1768C43.5882 49.1577 43.6364 49.1386 43.6749 49.1195C43.7135 49.1003 43.752 49.0812 43.7906 49.0717C43.8388 49.0525 43.887 49.043 43.9255 49.0334C43.9641 49.0239 44.0026 49.0047 44.0412 49.0047C44.0893 48.9952 44.1375 48.9952 44.1953 48.9856C44.2339 48.976 44.2821 48.9761 44.3206 48.9665C44.3688 48.9665 44.4266 48.9665 44.4845 48.9665C44.5326 48.9665 44.5712 48.9665 44.6194 48.9665C44.6772 48.9761 44.735 48.9856 44.7928 48.9952C44.841 49.0047 44.8796 49.0047 44.9278 49.0143C44.9856 49.0239 45.053 49.0525 45.1205 49.0621C45.1687 49.0717 45.2072 49.0812 45.2554 49.1003C45.3229 49.1195 45.3903 49.1577 45.4578 49.1864C45.4963 49.2055 45.5445 49.2151 45.5831 49.2342C45.6987 49.282 45.8144 49.3393 45.9204 49.4063L89.865 74.5783L89.8554 76.2801C89.8554 76.347 89.8458 76.3948 89.8265 76.4426C89.8168 76.4521 89.8072 76.4617 89.7976 76.4713C89.7301 76.5669 89.6048 76.5955 89.4603 76.5095L45.7083 51.4521L45.6216 51.4043C45.294 51.2131 44.9952 51.1653 44.7446 51.2227C44.629 51.2514 44.5326 51.3087 44.4363 51.3852C44.4074 51.4043 44.3784 51.4235 44.3592 51.4521C44.3303 51.4904 44.3013 51.5382 44.2724 51.586C44.2532 51.6147 44.2339 51.6338 44.2146 51.672C44.1857 51.7294 44.1761 51.7963 44.1568 51.8537C44.1472 51.8824 44.1375 51.911 44.1279 51.9397C44.1086 52.0353 44.099 52.15 44.099 52.2648L44.0893 55.6778C44.0893 56.6338 44.7639 57.7906 45.6794 58.3164L88.6026 82.9053L89.441 83.3833C89.653 83.5076 89.8265 83.804 89.8265 84.043L89.8072 85.7542L45.8818 60.5917C44.0412 59.5401 42.5474 56.978 42.5571 54.8747L42.5667 51.3087Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M89.8648 74.5879L45.9105 49.4158L106.036 14.7504L149.99 39.9225L89.8648 74.5879Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.953 71.7589C158.904 71.7685 158.856 71.778 158.798 71.7971C158.847 71.7685 158.895 71.7685 158.953 71.7589Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.012 71.8356C160.436 72.0746 160.697 72.5717 160.697 73.2887L160.706 78.2313C160.706 79.6845 159.646 81.4818 158.336 82.2275C159.704 81.4436 160.716 79.7132 160.706 78.2983L160.697 73.2218C160.697 73.0497 160.677 72.8776 160.649 72.7342C160.639 72.6864 160.62 72.6482 160.61 72.6004C160.581 72.5048 160.562 72.4092 160.523 72.3231C160.504 72.2753 160.465 72.2466 160.446 72.1988C160.408 72.1319 160.369 72.0554 160.321 72.0076C160.282 71.9694 160.244 71.9503 160.205 71.912C160.07 71.7973 159.926 71.7113 159.752 71.673L160.041 71.8356C160.022 71.8356 160.012 71.8356 160.012 71.8356Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.81 71.759C159.762 71.7399 159.714 71.7208 159.656 71.7112C159.714 71.7208 159.762 71.7399 159.81 71.759Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.251 71.6922C159.309 71.6826 159.357 71.6922 159.415 71.6922C159.357 71.6922 159.309 71.6826 159.251 71.6922Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.798 71.7877C158.847 71.7686 158.895 71.7686 158.953 71.7495C159.059 71.7208 159.155 71.6921 159.251 71.6826C159.309 71.673 159.357 71.6826 159.415 71.6826C159.502 71.6826 159.579 71.6825 159.656 71.6921C159.714 71.7017 159.762 71.7304 159.81 71.7399C159.878 71.759 159.945 71.7782 160.013 71.8164C160.022 71.8164 160.022 71.8164 160.032 71.826L159.743 71.6634C159.377 71.5774 158.924 71.6539 158.432 71.9311L158.307 72.0076C158.48 71.9216 158.644 71.8451 158.798 71.7877Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.509 68.7093C158.577 68.6806 158.635 68.6615 158.702 68.6328C158.808 68.5945 158.904 68.5467 159.01 68.5085C159.078 68.4894 159.145 68.4703 159.203 68.4511C159.299 68.4225 159.396 68.3938 159.483 68.3746C159.55 68.3555 159.618 68.3555 159.685 68.346C159.772 68.3364 159.858 68.3173 159.945 68.3077C160.013 68.2982 160.08 68.3077 160.148 68.3077C160.225 68.3077 160.311 68.2982 160.388 68.3077C160.456 68.3077 160.514 68.3269 160.572 68.3269C160.649 68.3364 160.726 68.3364 160.793 68.3555C160.851 68.3651 160.909 68.3842 160.967 68.4033C161.034 68.4225 161.111 68.4416 161.179 68.4607C161.237 68.4798 161.285 68.5085 161.343 68.5372C161.41 68.5659 161.468 68.5945 161.535 68.6232H161.545L72.0173 17.0171C71.1114 16.5008 69.8586 16.5678 68.4805 17.3613L158.008 68.9674C158.172 68.8718 158.336 68.7857 158.509 68.7093Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08386 68.9292L3.10314 71.4722L92.6308 123.088L92.6018 120.535L3.08386 68.9292Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.18 119.55L94.4328 118.833L4.90525 67.2272L3.65244 67.9443C3.33442 68.1259 3.08386 68.5657 3.08386 68.929L92.6115 120.535C92.6018 120.172 92.862 119.732 93.18 119.55Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.345 82.2274C159.656 81.4721 160.726 79.6844 160.716 78.2312L160.706 73.2886C160.706 72.5716 160.437 72.0744 160.022 71.8354C159.964 71.7972 159.887 71.7876 159.82 71.7589C159.772 71.7398 159.724 71.7207 159.666 71.7111C159.589 71.692 159.502 71.7016 159.425 71.7016C159.367 71.7016 159.319 71.692 159.261 71.7016C159.165 71.7111 159.059 71.7398 158.962 71.7685C158.914 71.7781 158.866 71.7876 158.808 71.8067C158.654 71.8641 158.49 71.931 158.326 72.0266L93.1705 109.34C92.9488 109.464 92.7657 109.426 92.6694 109.283C92.6983 109.321 92.7175 109.359 92.7561 109.378L4.8764 58.7092L4.90531 67.2178L94.4329 118.824L158.345 82.2274Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.573 108.987C92.573 109.082 92.5923 109.159 92.6212 109.226C92.5923 109.159 92.573 109.082 92.573 108.987Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7464 109.369C92.7078 109.35 92.6885 109.312 92.6596 109.273C92.65 109.254 92.6307 109.245 92.6211 109.225C92.5922 109.159 92.5729 109.082 92.5729 108.986L92.5633 106.443L3.04529 54.8373L3.05493 57.3804C3.05493 57.562 3.12238 57.6958 3.22839 57.7532L4.88595 58.7092L92.7464 109.369Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.981 71.7972C162.981 70.2388 162.422 69.1394 161.525 68.6232C161.468 68.5849 161.4 68.5658 161.333 68.5371C161.275 68.5084 161.227 68.4798 161.169 68.4606C161.101 68.432 161.034 68.4224 160.957 68.4033C160.899 68.3842 160.841 68.365 160.783 68.3555C160.706 68.3364 160.629 68.3364 160.562 68.3268C160.504 68.3172 160.437 68.3077 160.379 68.3077C160.302 68.3077 160.225 68.3077 160.138 68.3077C160.07 68.3077 160.012 68.3077 159.935 68.3077C159.849 68.3172 159.762 68.3364 159.675 68.3459C159.608 68.3555 159.54 68.365 159.473 68.3746C159.376 68.3937 159.29 68.4224 159.193 68.4511C159.126 68.4702 159.058 68.4798 159.001 68.5084C158.904 68.5467 158.798 68.5849 158.692 68.6327C158.625 68.6614 158.567 68.6805 158.499 68.7092C158.336 68.7857 158.162 68.8717 157.989 68.9673L92.5536 106.443L92.5632 108.986C92.5632 109.082 92.5825 109.159 92.6114 109.225C92.621 109.245 92.6403 109.254 92.65 109.273C92.756 109.417 92.9391 109.455 93.1511 109.331L158.307 72.0171L158.432 71.9406C158.924 71.6633 159.367 71.5868 159.743 71.6729C159.916 71.7111 160.061 71.7972 160.196 71.9119C160.234 71.9406 160.273 71.9692 160.311 72.0075C160.359 72.0649 160.398 72.1318 160.437 72.1987C160.465 72.2369 160.494 72.2752 160.514 72.323C160.552 72.409 160.581 72.5046 160.6 72.6002C160.61 72.648 160.629 72.6863 160.639 72.7341C160.668 72.887 160.687 73.0496 160.687 73.2216L160.697 78.2981C160.697 79.7226 159.694 81.4434 158.326 82.2274L94.4232 118.833L93.1704 119.551C92.8523 119.732 92.6018 120.172 92.6018 120.535L92.6307 123.088L158.047 85.6213C160.793 84.0534 163.01 80.2388 163 77.1031L162.981 71.7972Z",
    fill: "url(#paint9_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5633 106.453L157.998 68.9769L68.4804 17.3612L3.04529 54.8373L92.5633 106.453Z",
    fill: "url(#paint10_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M155.907 55.0668C155.859 55.0763 155.811 55.0859 155.753 55.105C155.811 55.0859 155.859 55.0763 155.907 55.0668Z",
    fill: "url(#paint11_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.967 55.1434C157.391 55.3728 157.651 55.8795 157.651 56.5965L157.661 61.5392C157.661 62.9923 156.601 64.7896 155.29 65.5353C156.659 64.7514 157.671 63.021 157.661 61.6061L157.651 56.5296C157.651 56.3575 157.632 56.1854 157.603 56.042C157.594 55.9942 157.574 55.956 157.565 55.9082C157.536 55.8126 157.516 55.717 157.478 55.6309C157.459 55.5831 157.42 55.5545 157.401 55.5067C157.362 55.4397 157.324 55.3632 157.276 55.3154C157.237 55.2772 157.198 55.2581 157.16 55.2198C157.025 55.1051 156.88 55.0191 156.707 54.9808L156.996 55.1434C156.986 55.1434 156.977 55.1434 156.967 55.1434Z",
    fill: "url(#paint12_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.765 55.0668C156.717 55.0477 156.668 55.0286 156.611 55.019C156.668 55.0286 156.717 55.0477 156.765 55.0668Z",
    fill: "url(#paint13_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.206 55C156.264 54.9904 156.312 55 156.37 55C156.312 55.0095 156.264 55 156.206 55Z",
    fill: "url(#paint14_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.753 55.105C155.801 55.0859 155.85 55.0859 155.907 55.0668C156.013 55.0381 156.11 55.0094 156.206 54.9999C156.264 54.9903 156.312 54.9999 156.37 54.9999C156.457 54.9999 156.534 54.9999 156.611 55.0094C156.669 55.019 156.717 55.0477 156.765 55.0572C156.833 55.0764 156.9 55.0955 156.967 55.1337C156.977 55.1337 156.977 55.1337 156.987 55.1433L156.698 54.9808C156.331 54.8947 155.878 54.9712 155.387 55.2484L155.262 55.3249C155.435 55.2293 155.599 55.1528 155.753 55.105Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M155.464 52.0267C155.532 51.998 155.589 51.9789 155.657 51.9502C155.763 51.912 155.859 51.8642 155.965 51.8259C156.033 51.8068 156.1 51.7877 156.158 51.7686C156.254 51.7399 156.351 51.7112 156.437 51.6921C156.505 51.673 156.572 51.673 156.64 51.6634C156.727 51.6539 156.813 51.6347 156.9 51.6252C156.967 51.6156 157.035 51.6252 157.102 51.6252C157.179 51.6252 157.266 51.6156 157.343 51.6252C157.411 51.6252 157.469 51.6443 157.526 51.6443C157.603 51.6539 157.681 51.6539 157.748 51.673C157.806 51.6825 157.864 51.7017 157.921 51.7208C157.989 51.7399 158.066 51.759 158.134 51.7781C158.191 51.7973 158.24 51.826 158.297 51.8546C158.365 51.8833 158.423 51.912 158.49 51.9407H158.5L68.9721 0.334558C68.0662 -0.191255 66.8134 -0.114773 65.4353 0.678726L154.963 52.2848C155.127 52.1892 155.3 52.1032 155.464 52.0267Z",
    fill: "url(#paint15_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0385742 52.2371L0.0674852 54.7896L89.5854 106.396L89.5662 103.853L0.0385742 52.2371Z",
    fill: "url(#paint16_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1348 102.858L91.3876 102.141L1.85997 50.5351L0.607157 51.2521C0.289136 51.4338 0.0385742 51.8735 0.0385742 52.2368L89.5662 103.843C89.5662 103.489 89.8168 103.04 90.1348 102.858Z",
    fill: "url(#paint17_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.3 65.5353C156.611 64.7801 157.68 62.9923 157.671 61.5392L157.661 56.5965C157.661 55.8795 157.391 55.3824 156.977 55.1434C156.919 55.1051 156.842 55.0956 156.775 55.0669C156.726 55.0478 156.678 55.0286 156.62 55.0191C156.543 55 156.457 55.0095 156.379 55.0095C156.322 55.0095 156.273 55 156.216 55.0095C156.119 55.0191 156.013 55.0478 155.917 55.0764C155.869 55.086 155.82 55.0956 155.763 55.1147C155.608 55.172 155.445 55.239 155.281 55.3346L90.1155 92.6386C89.8939 92.7629 89.7107 92.7246 89.6144 92.5812C89.6433 92.6194 89.6626 92.6577 89.7011 92.6768L1.8407 42.0267L1.86961 50.5353L91.3972 102.141L155.3 65.5353Z",
    fill: "url(#paint18_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5278 92.304C89.5278 92.3996 89.547 92.476 89.576 92.5429C89.547 92.476 89.5278 92.39 89.5278 92.304Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7011 92.6768C89.6625 92.6577 89.6433 92.6195 89.6143 92.5812C89.6047 92.5621 89.5854 92.5526 89.5758 92.5334C89.5469 92.4665 89.5276 92.39 89.5276 92.2944L89.518 89.7514L0 38.1548L0.00963699 40.6979C0.00963699 40.8795 0.0770959 41.0134 0.183103 41.0803L1.84066 42.0363L89.7011 92.6768Z",
    fill: "url(#paint19_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M159.945 55.105C159.945 53.5466 159.386 52.4472 158.49 51.931C158.432 51.8927 158.365 51.8736 158.297 51.8449C158.239 51.8162 158.191 51.7876 158.133 51.7684C158.066 51.7398 157.998 51.7302 157.921 51.7111C157.863 51.692 157.806 51.6728 157.748 51.6633C157.671 51.6442 157.594 51.6442 157.526 51.6346C157.468 51.625 157.401 51.6155 157.343 51.6155C157.266 51.6155 157.189 51.6155 157.102 51.6155C157.035 51.6155 156.977 51.6155 156.9 51.6155C156.813 51.625 156.726 51.6442 156.639 51.6537C156.572 51.6633 156.505 51.6728 156.437 51.6824C156.341 51.7015 156.254 51.7302 156.158 51.7589C156.09 51.778 156.023 51.7876 155.965 51.8162C155.869 51.8545 155.763 51.8927 155.657 51.9405C155.589 51.9692 155.531 51.9883 155.464 52.017C155.3 52.0935 155.126 52.1795 154.953 52.2751L89.5179 89.7512L89.5275 92.2942C89.5275 92.3898 89.5468 92.4663 89.5757 92.5332C89.5853 92.5524 89.6046 92.5619 89.6143 92.581C89.7203 92.7244 89.9034 92.7627 90.1154 92.6384L155.271 55.3248L155.396 55.2484C155.888 54.9711 156.331 54.8946 156.707 54.9807C156.88 55.0189 157.025 55.105 157.16 55.2197C157.198 55.2484 157.237 55.277 157.276 55.3153C157.324 55.3726 157.362 55.4396 157.401 55.5065C157.43 55.5447 157.459 55.583 157.478 55.6308C157.516 55.7168 157.545 55.8124 157.565 55.908C157.574 55.9558 157.594 55.9941 157.603 56.0419C157.632 56.1948 157.651 56.3574 157.651 56.5294L157.661 61.6059C157.661 63.0304 156.659 64.7512 155.29 65.5352L91.3778 102.141L90.125 102.858C89.807 103.04 89.5564 103.48 89.5564 103.843L89.5853 106.396L155.001 68.929C157.748 67.3612 159.964 63.5466 159.955 60.4109L159.945 55.105Z",
    fill: "url(#paint20_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5276 89.7609L154.953 52.2848L65.4351 0.678711L0 38.1548L89.5276 89.7609Z",
    fill: "url(#paint21_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2748 50.1912C45.3133 50.2008 45.3422 50.2008 45.3711 50.2103C45.3422 50.2008 45.3133 50.2008 45.2748 50.1912Z",
    fill: "url(#paint22_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5615 50.2484C44.2821 50.4014 44.099 50.7455 44.099 51.2235L44.0893 54.5409C44.0893 55.5161 44.8025 56.7207 45.6794 57.2274C44.7543 56.7015 44.0797 55.5448 44.0893 54.5887L44.099 51.1757C44.099 51.061 44.1086 50.9463 44.1279 50.8507C44.1375 50.822 44.1472 50.7933 44.1568 50.7646C44.1761 50.6977 44.1953 50.6308 44.2146 50.583C44.2339 50.5543 44.2532 50.5256 44.2724 50.497C44.3013 50.4492 44.3206 50.4014 44.3592 50.3631C44.3784 50.3344 44.4074 50.3249 44.4363 50.2962C44.523 50.2197 44.629 50.1623 44.7446 50.1337L44.5519 50.2484H44.5615Z",
    fill: "url(#paint23_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6964 50.1913C44.735 50.1817 44.7639 50.1626 44.8024 50.153C44.7639 50.1626 44.735 50.1817 44.6964 50.1913Z",
    fill: "url(#paint24_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0723 50.1436C45.0338 50.1436 44.9952 50.1436 44.9663 50.1436C45.0049 50.1531 45.0338 50.1436 45.0723 50.1436Z",
    fill: "url(#paint25_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3807 50.2199C45.3422 50.2104 45.3133 50.2104 45.2844 50.2008C45.2169 50.1817 45.1494 50.1626 45.082 50.153C45.0434 50.153 45.0049 50.153 44.976 50.153C44.9181 50.153 44.8603 50.153 44.8121 50.1626C44.7736 50.1721 44.7447 50.1817 44.7061 50.2008C44.658 50.2199 44.6098 50.2295 44.5712 50.2486H44.5616L44.7543 50.1339C45.0049 50.0765 45.3036 50.1243 45.6313 50.3155L45.718 50.3633C45.5927 50.2964 45.4867 50.2486 45.3807 50.2199Z",
    fill: "#E6E6E6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5733 48.1453C45.5348 48.1262 45.4866 48.1166 45.448 48.0975C45.3806 48.0688 45.3131 48.0402 45.2457 48.0115C45.1975 47.9924 45.1589 47.9828 45.1107 47.9732C45.0433 47.9541 44.9855 47.935 44.918 47.9254C44.8698 47.9159 44.8313 47.9159 44.7831 47.9063C44.7253 47.8968 44.6674 47.8872 44.6096 47.8776C44.5614 47.8776 44.5229 47.8776 44.4747 47.8776C44.4169 47.8776 44.3687 47.8681 44.3109 47.8776C44.2723 47.8776 44.2241 47.8872 44.1856 47.8968C44.1374 47.9063 44.0796 47.9063 44.0314 47.9159C43.9928 47.9254 43.9543 47.935 43.9158 47.9446C43.8676 47.9541 43.8194 47.9637 43.7808 47.9828C43.7423 47.9924 43.7037 48.021 43.6652 48.0306C43.6266 48.0497 43.5785 48.0688 43.5399 48.088C43.5399 48.088 43.5399 48.088 43.5303 48.088L103.655 13.4226C104.263 13.0688 105.101 13.1262 106.026 13.652L45.9106 48.327C45.795 48.26 45.689 48.2027 45.5733 48.1453Z",
    fill: "url(#paint26_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M149.961 48.2886L149.942 49.9999L89.8169 84.6653L89.8362 82.954L149.961 48.2886Z",
    fill: "url(#paint27_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4506 82.2945L88.6122 81.8165L148.737 47.1511L149.576 47.6291C149.788 47.7534 149.961 48.0498 149.961 48.2888L89.8361 82.9542C89.8361 82.7152 89.6626 82.4188 89.4506 82.2945Z",
    fill: "url(#paint28_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.689 57.2276C44.812 56.7209 44.0892 55.5163 44.0989 54.5412L44.1085 51.2238C44.1085 50.7457 44.282 50.4016 44.5711 50.2486C44.6096 50.2295 44.6578 50.2104 44.706 50.2008C44.7445 50.1912 44.7734 50.1721 44.812 50.1626C44.8602 50.153 44.918 50.153 44.9758 50.153C45.0144 50.153 45.0433 50.1434 45.0818 50.153C45.1493 50.1626 45.2167 50.1817 45.2842 50.2008C45.3228 50.2104 45.3517 50.2104 45.3806 50.2199C45.4866 50.2582 45.5926 50.306 45.7082 50.3729L89.4602 75.4303C89.6047 75.5163 89.73 75.4876 89.7974 75.392C89.7782 75.4207 89.7589 75.4398 89.7396 75.4589L148.747 41.4341L148.728 47.1511L88.6121 81.8069L45.689 57.2276Z",
    fill: "url(#paint29_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8553 75.2009C89.8553 75.2678 89.8456 75.3156 89.8264 75.3634C89.8456 75.3156 89.8553 75.2582 89.8553 75.2009Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7397 75.4495C89.7686 75.44 89.7782 75.4113 89.7975 75.3826C89.8071 75.3731 89.8168 75.3635 89.8264 75.3539C89.8457 75.3157 89.8553 75.2583 89.8553 75.1914L89.865 73.4897L149.99 38.8243L149.98 40.526C149.98 40.6503 149.932 40.7363 149.865 40.7841L148.747 41.4247L89.7397 75.4495Z",
    fill: "url(#paint30_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5667 50.2199C42.5667 49.1683 42.9425 48.4322 43.5497 48.088C43.5882 48.0689 43.6364 48.0498 43.6749 48.0306C43.7135 48.0115 43.752 47.9924 43.7906 47.9828C43.8388 47.9637 43.887 47.9542 43.9255 47.9446C43.9641 47.935 44.0026 47.9159 44.0412 47.9159C44.0893 47.9064 44.1375 47.9064 44.1953 47.8968C44.2339 47.8872 44.2821 47.8872 44.3206 47.8777C44.3688 47.8777 44.4266 47.8777 44.4845 47.8777C44.5326 47.8777 44.5712 47.8777 44.6194 47.8777C44.6772 47.8872 44.735 47.8968 44.7928 47.9064C44.841 47.9159 44.8796 47.9159 44.9278 47.9255C44.9856 47.935 45.053 47.9637 45.1205 47.9733C45.1687 47.9828 45.2072 47.9924 45.2554 48.0115C45.3229 48.0306 45.3903 48.0689 45.4578 48.0976C45.4963 48.1167 45.5445 48.1263 45.5831 48.1454C45.6987 48.1932 45.8144 48.2505 45.9204 48.3175L89.865 73.4895L89.8554 75.1913C89.8554 75.2582 89.8458 75.306 89.8265 75.3538C89.8168 75.3634 89.8072 75.3729 89.7976 75.3825C89.7301 75.4781 89.6048 75.5068 89.4603 75.4207L45.7083 50.3633L45.6216 50.3155C45.294 50.1243 44.9952 50.0765 44.7446 50.1339C44.629 50.1626 44.5326 50.2199 44.4363 50.2964C44.4074 50.3155 44.3784 50.3347 44.3592 50.3633C44.3303 50.4016 44.3013 50.4494 44.2724 50.4972C44.2532 50.5259 44.2339 50.545 44.2146 50.5832C44.1857 50.6406 44.1761 50.7075 44.1568 50.7649C44.1472 50.7936 44.1375 50.8222 44.1279 50.8509C44.1086 50.9465 44.099 51.0612 44.099 51.176L44.0893 54.589C44.0893 55.545 44.7639 56.7018 45.6794 57.2276L88.6026 81.8165L89.441 82.2945C89.653 82.4188 89.8265 82.7152 89.8265 82.9542L89.8072 84.6655L45.8818 59.5029C44.0412 58.4513 42.5474 55.8892 42.5571 53.7859L42.5667 50.2199Z",
    fill: "url(#paint31_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8651 73.499L45.9108 48.327L106.036 13.6616L149.99 38.8336L89.8651 73.499Z",
    fill: "url(#paint32_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 158.793,
    y1: 71.758,
    x2: 158.822,
    y2: 71.8393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 158.25,
    y1: 71.4288,
    x2: 162.067,
    y2: 72.0167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 159.65,
    y1: 71.7101,
    x2: 159.693,
    y2: 71.8055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 159.245,
    y1: 71.6878,
    x2: 159.246,
    y2: 71.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 68.4757,
    y1: 42.832,
    x2: 161.532,
    y2: 42.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 3.08386,
    y1: 81.5017,
    x2: 95.1188,
    y2: 87.1127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 3.08386,
    y1: 79.6023,
    x2: 96.9452,
    y2: 85.5329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 34.8664,
    y1: 94.7424,
    x2: 100.248,
    y2: 67.9274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2194,
    stopColor: "#E3E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 52.8952,
    y1: 61.4301,
    x2: 49.9664,
    y2: 73.7316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 92.5536,
    y1: 81.0245,
    x2: 165.063,
    y2: 84.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 3.04529,
    y1: 38.0432,
    x2: 162.241,
    y2: 48.2525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 155.747,
    y1: 55.0659,
    x2: 155.777,
    y2: 55.1471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 155.205,
    y1: 54.7366,
    x2: 159.021,
    y2: 55.3245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 156.605,
    y1: 55.0179,
    x2: 156.648,
    y2: 55.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 156.2,
    y1: 54.9955,
    x2: 156.202,
    y2: 55.0158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 62.0859,
    y1: -1.21042,
    x2: 123.679,
    y2: 73.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: -3.18419,
    y1: 50.984,
    x2: 61.3776,
    y2: 124.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: -3.24905,
    y1: 49.3018,
    x2: 59.9754,
    y2: 123.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 36.8472,
    y1: 75.5372,
    x2: 129.515,
    y2: 42.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2194,
    stopColor: "#E3E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -3.22832,
    y1: 36.8934,
    x2: 61.8061,
    y2: 110.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 86.9829,
    y1: 50.3481,
    x2: 152.284,
    y2: 107.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: -5.57672,
    y1: -1.38232,
    x2: 99.8129,
    y2: 124.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 45.2713,
    y1: 50.1908,
    x2: 45.2836,
    y2: 50.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 44.032,
    y1: 49.9695,
    x2: 46.592,
    y2: 50.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 44.6926,
    y1: 50.1521,
    x2: 44.7305,
    y2: 50.2241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 44.9625,
    y1: 50.1435,
    x2: 44.9631,
    y2: 50.1537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8562BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#461692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 106.04,
    y1: 30.7666,
    x2: 43.5417,
    y2: 30.7666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 124.542,
    y1: 76.4374,
    x2: 118.958,
    y2: 64.2964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 149.959,
    y1: 65.0523,
    x2: 88.6108,
    y2: 65.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 128.612,
    y1: 65.6304,
    x2: 84.7011,
    y2: 47.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0311,
    stopColor: "#DDDBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2194,
    stopColor: "#E3E2FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 116.504,
    y1: 43.2576,
    x2: 118.471,
    y2: 51.5195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 89.8615,
    y1: 66.2701,
    x2: 42.5569,
    y2: 66.2701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0175,
    stopColor: "#FED488"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    stopColor: "#FED081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4049,
    stopColor: "#FCC36D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6824,
    stopColor: "#FAAF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9935,
    stopColor: "#F7941F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 45.9108,
    y1: 27.5524,
    x2: 152.84,
    y2: 34.4103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F98905"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7628"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1A3C9Fc1);
export default __webpack_public_path__ + "static/media/feature-1.a3c9fc1.a3c9fc1be51f74956ef7d70c75e20972.svg";
export { ForwardRef as ReactComponent };